import ContentBody from "../common/content-body/ContentBody";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import { dmsFilterParams } from "./state";
import {useContext, useEffect, useMemo, useState} from "react";
import SectionHeader from "../../../util/component/SectionHeader";
import {IServerSideDatasource} from "ag-grid-community";
import { search, exportDMS  } from "./dmsSearch.actions";
import {SEARCH_FILTERS_FORM_INITIAL_VALUES} from "./config";
import {useForm} from "react-hook-form";
import {IDmsSearchFilters} from "./models";
import {filterObject} from "../utils";

import DmsFilter from "./partials/DmsFilter";
import DmsTable from "./partials/DmsTable";
import { ISortBy } from "../../booking/api/types";
import { useMutation } from "@tanstack/react-query";
import { deepClone } from "../../../util/state/commonFunctions";
import CustomLoader from "../../../util/component/CustomLoader";
import * as Mui from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileSaver from "file-saver";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";


const SearchDms = () => {
    const {t} = useTranslation(['network', 'translation']);
    const [filterExpanded, setFilterExpanded] = useState(false);
    const [filterParams, setFilterParams] = useRecoilState(dmsFilterParams);
    const dmsSearchListMutation = useMutation(search);
    const dmsExportListMutation = useMutation(exportDMS);
    const [loading, setLoading] = useState(false);
    const {globalData} = useContext(GlobalContext);

    let filterParamsClone = deepClone(filterParams);

    const searchDmsForm = useForm<IDmsSearchFilters>({
        defaultValues: SEARCH_FILTERS_FORM_INITIAL_VALUES
    });

    useEffect(() => {
        if (globalData.user.legalEntities.length === 1) {
            searchDmsForm.setValue('tenants', globalData.user.legalEntities);
        } else if (globalData.user.legalEntities.length > 1) {
            searchDmsForm.setValue('tenants', globalData.user.legalEntities.filter((elem: any) => elem.name !== 'all'));
            searchDmsForm.setValue('dealers', globalData.user.dealers.filter((elem: any) => elem.name !== 'all'));
        }

        const data = searchDmsForm.getValues();
        setFilterParams(filterObject(data, x => JSON.stringify(data[x]) !== JSON.stringify(SEARCH_FILTERS_FORM_INITIAL_VALUES[x])));
    }, []);

    const handleSearch = (data: any) => {

        console.log('handleSearch with data: ' + JSON.stringify(data));     //Values of filters
        setFilterExpanded(false);
        setFilterParams(filterObject(data, x => JSON.stringify(data[x]) !== JSON.stringify(SEARCH_FILTERS_FORM_INITIAL_VALUES[x])));
        //Prende solo i filtri popolati
        //console.log('handleSearch filterObject After: ' + JSON.stringify(filterObject(data, x => JSON.stringify(data[x]) !== JSON.stringify(SEARCH_FILTERS_FORM_INITIAL_VALUES[x]))));
    };

    const serverSideDatasource: IServerSideDatasource = useMemo(() => ({
        getRows: async(params) => {
            const sortBy: ISortBy | undefined = params.request.sortModel[0] ? {
                field: params.request.sortModel[0].colId,
                order: params.request.sortModel[0].sort
            } : undefined;

            const pagination = Number(params.request.endRow) - Number(params.request.startRow);

            if (!filterParamsClone) {
                filterParamsClone = {};
            }

            const {startRow: startIndex, endRow: endIndex} = params.request

            filterParamsClone['paramRequest'] = { pagination, sortBy, startIndex, endIndex };

            if (!!filterParamsClone.tenants) {
                console.log('filterParamsClone.tenants before: ' + JSON.stringify(filterParamsClone.tenants));     //Values of filters
                const ind = filterParamsClone.tenants.findIndex((elem: any) => elem.name === 'all');
                if (ind > -1) {
                    filterParamsClone.tenants =
                        globalData.user.legalEntities
                            .filter((elem: any) => elem.name !== 'all')
                            .map((elem: any) => elem.name);
                } else {
                
                    console.log('sample item:', filterParamsClone.tenants[0]);
                    //filterParamsClone.tenants = filterParamsClone.tenants.map((elem: any) => elem.name);
                    const toName = (t: any) => (typeof t === 'string' ? t : t?.name);
                    if (Array.isArray(filterParamsClone.tenants) && filterParamsClone.tenants.length) {
                        const hasAll = filterParamsClone.tenants.some((t : any) => toName(t) === 'all');

                        if (hasAll) {
                            filterParamsClone.tenants =
                            (globalData.user?.legalEntities ?? [])
                                .map(toName)
                                .filter((n: any): n is string => !!n && n !== 'all');
                        } else {
                            filterParamsClone.tenants =
                            filterParamsClone.tenants
                                .map(toName)
                                .filter((n: any): n is string => !!n);
                        }
                    }
                }
            }

            console.log('serverSideDatasource with filterParamsClone: ' + JSON.stringify(filterParamsClone));     //Values of filters
            dmsSearchListMutation.mutateAsync(filterParamsClone)
                .then((response: any) => {
                    params.success({
                        rowData: response.listMobilityStore,
                        rowCount: response.params.totCount
                    });
                    response.params.totCount === 0 && params.api.showNoRowsOverlay();
                })
                .catch(() => {
                    params.fail();
                    params.api.hideOverlay();
                })                
        }
    }), [filterParams]);
	
    const getFileName = () => {

        if (searchDmsForm.control._formValues){

            if (searchDmsForm.control._formValues.name && searchDmsForm.control._formValues.name.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.identificationCode && searchDmsForm.control._formValues.identificationCode.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.sapId && searchDmsForm.control._formValues.sapId.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.dmsType && searchDmsForm.control._formValues.dmsType.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.dmsCategory && searchDmsForm.control._formValues.dmsCategory.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.currentStatus && searchDmsForm.control._formValues.currentStatus.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.currentAttribute && searchDmsForm.control._formValues.currentAttribute.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.region && searchDmsForm.control._formValues.region.length > 0)
                return "mobility_stores_filtered.xlsx";            
            else if (searchDmsForm.control._formValues.province && searchDmsForm.control._formValues.province.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.city && searchDmsForm.control._formValues.city.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.address && searchDmsForm.control._formValues.address.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.streetNumber && searchDmsForm.control._formValues.streetNumber.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.serviceType && searchDmsForm.control._formValues.serviceType.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.chargingStationStatus && searchDmsForm.control._formValues.chargingStationStatus.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.chargingColumnId && searchDmsForm.control._formValues.chargingColumnId.length > 0)
                return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.certificationProtocolIdentifyingCode && searchDmsForm.control._formValues.certificationProtocolIdentifyingCode.length > 0)
                  return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.companyName && searchDmsForm.control._formValues.companyName.length > 0)
               return "mobility_stores_filtered.xlsx";
            else if (searchDmsForm.control._formValues.keyless && searchDmsForm.control._formValues.keyless.length > 0)
                return "mobility_stores_filtered.xlsx";
            else
                return "mobility_stores.xlsx";
        } else
            return "mobility_stores.xlsx";

    }

    const handleDownloadExcel = () => {
        setLoading(true);
    
        if (!filterParamsClone) {
            filterParamsClone = {};
        }

        if (!!filterParamsClone.tenants) {
            const ind = filterParamsClone.tenants.findIndex((elem: any) => elem.name === 'all');
            if (ind > -1) {
                filterParamsClone.tenants =
                    globalData.user.legalEntities
                        .filter((elem: any) => elem.name !== 'all')
                        .map((elem: any) => elem.name);
            } else {
                filterParamsClone.tenants = filterParamsClone.tenants.map((elem: any) => elem.name);
            }
        }

        // if (!!filterParamsClone.dealers) {
        //     const ind = filterParamsClone.dealers.findIndex((elem: any) => elem.name === 'all');
        //     if (ind > -1) {
        //         filterParamsClone.dealers =
        //             globalData.user.legalEntities
        //                 .filter((elem: any) => elem.name !== 'all')
        //                 .map((elem: any) => elem.name);
        //     } else {
        //         filterParamsClone.dealers = filterParamsClone.dealers.map((elem: any) => elem.name);
        //     }
        // }

        dmsExportListMutation.mutateAsync(filterParamsClone)
            .then((response: any) => {
              setLoading(false);
    
              console.log(JSON.stringify(response));
              const filename = getFileName();            
              var blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              FileSaver.saveAs(blob, filename);
            });
        
      };

    return (
        <>
            <SectionHeader title={t('searchDms.title')}/>
            <ContentBody>
                <DmsFilter
                    handleSearch={handleSearch}
                    searchDmsForm={searchDmsForm}
                    filterExpandedState={[filterExpanded, setFilterExpanded]}
                />
				<Mui.Box
                        sx={{
                            backgroundColor: "white",
                            border: " 1px solid #dbe4e9",
                            borderRadius: "2px",
                            padding: "9px 1px 3px 2px",
                        }}
                        >

                        <Mui.Grid
                            container
                            spacing={2}
                            alignItems="center"
                            direction="row"
                            justifyContent="flex-end"
                        >
                        <Mui.Grid item>
                            <Mui.Button
                                variant="text"
                                size="icon"
                                onClick={handleDownloadExcel}
                                color="accent"
                                //disabled={disableDownloadExcel}
                            >
                                <Mui.Tooltip title={t("searchDms.download")}>
                                <FileDownloadIcon />
                                </Mui.Tooltip>
                            </Mui.Button>
                            </Mui.Grid>

                        </Mui.Grid>
                </Mui.Box>
                <DmsTable serverSideDatasource={serverSideDatasource}/>
            </ContentBody>
            <CustomLoader loading={dmsSearchListMutation.isLoading || loading} />
        </>
    )
}

export default SearchDms;
